import React from 'react';
import PropTypes from 'prop-types';

/**
 * Draws unit wrapper
 * */
const UnitWrapper = ({ title, children, preview }) => (
  <li className="unit-item">
    <div className="unit-item-container">
      <div className="unit-item-title">{title}</div>
      {children}
    </div>
    {preview}
  </li>
);

UnitWrapper.displayName = 'UnitWrapper';

UnitWrapper.propTypes = {
  title: PropTypes.any.isRequired,
  preview: PropTypes.any.isRequired,
  children: PropTypes.any,
};

export default UnitWrapper;
